import React, { useEffect, useRef, useState } from 'react';
import { Card, Badge, Alert } from 'react-bootstrap';

const MapSelector = ({ onLocationSelect, selectedLocation }) => {
    const markerRef = useRef(null);
    const mapRef = useRef(null);
    const [map, setMap] = useState(null);

    useEffect(() => {
        if (!mapRef.current || map) return;

        const initMap = () => {
            if (!window.L) {
                console.error('Leaflet no está cargado');
                return;
            }

            try {
                const newMap = window.L.map(mapRef.current, {
                    center: [-26.8083, -65.2176],
                    zoom: 13,
                    zoomControl: true
                });

                window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '© OpenStreetMap contributors',
                    maxZoom: 19
                }).addTo(newMap);

                newMap.on('click', (e) => {
                    const { lat, lng } = e.latlng;

                    // Remove existing marker using ref
                    if (markerRef.current) {
                        newMap.removeLayer(markerRef.current);
                    }

                    // Add new marker
                    const newMarker = window.L.marker([lat, lng], {
                        draggable: true
                    }).addTo(newMap);

                    // Update ref
                    markerRef.current = newMarker;

                    newMarker.on('dragend', (event) => {
                        const position = event.target.getLatLng();
                        onLocationSelect({
                            lat: position.lat.toFixed(6),
                            lng: position.lng.toFixed(6)
                        });
                    });

                    onLocationSelect({
                        lat: lat.toFixed(6),
                        lng: lng.toFixed(6)
                    });
                });

                setMap(newMap);
            } catch (error) {
                console.error('Error inicializando el mapa:', error);
            }
        };

        // Load Leaflet if not already loaded
        if (!window.L) {
            const leafletCSS = document.createElement('link');
            leafletCSS.rel = 'stylesheet';
            leafletCSS.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
            document.head.appendChild(leafletCSS);

            const leafletJS = document.createElement('script');
            leafletJS.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
            leafletJS.onload = initMap;
            document.head.appendChild(leafletJS);
        } else {
            initMap();
        }

        return () => {
            if (map) {
                map.remove();
            }
        };
    }, [map]);

    return (
        <Card className="mb-3">
            <Card.Header className="bg-info text-white">
                <strong>📍 Selección de Ubicación Geográfica</strong>
            </Card.Header>
            <Card.Body>
                <div
                    ref={mapRef}
                    style={{
                        height: '400px',
                        width: '100%',
                        borderRadius: '8px',
                        border: '2px solid #dee2e6'
                    }}
                />

                <Alert variant="warning" className="mt-3 mb-0">
                    <small>
                        <strong>Importante:</strong> La ubicación seleccionada es orientativa y no reemplaza la información contenida en los planos georreferenciados presentados.
                    </small>
                </Alert>

                {selectedLocation && (
                    <div className="mt-3">
                        <Badge bg="success" className="me-2">
                            Latitud: {selectedLocation.lat}
                        </Badge>
                        <Badge bg="success">
                            Longitud: {selectedLocation.lng}
                        </Badge>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default MapSelector;
